export default __webpack_public_path__ + "assets/images/84401d1bb2ccc9836945cf0a8361350e.jpg";